import Vue from "vue";

export const LineItemEventBus = new Vue();

export const LineItemCalculationEventBus = new Vue();
